import { get, map, mapValues } from 'lodash'
import { getReq } from '../../utils/request'

export type FilterOption = {
	value: number
	label: string
}

const OPTIONS_LIMIT = 100

const normalize = (queries: any) => mapValues(queries, (query) => query || undefined)

export const fetchJobOptions = async (search: string | null = null): Promise<FilterOption[]> => {
	const { data } = await getReq('/api/admin/jobs/store-items', normalize({
		limit: OPTIONS_LIMIT,
		page: 1,
		search
	}))

	return map(get(data, 'jobs', []), (job: any) => ({
		value: job.id,
		label: job.address
	}))
}

export const fetchStoreItemOptions = async (search: string | null = null): Promise<FilterOption[]> => {
	const { data } = await getReq('/api/admin/store-items', normalize({
		limit: OPTIONS_LIMIT,
		page: 1,
		search
	}))

	return map(get(data, 'storeItems', []), (storeItem: any) => ({
		value: storeItem.id,
		label: storeItem.name
	}))
}

export const fetchUserOptions = async (search: string | null = null): Promise<FilterOption[]> => {
	const { data } = await getReq('/api/admin/users', normalize({
		limit: OPTIONS_LIMIT,
		page: 1,
		search
	}))

	return map(get(data, 'users', []), (user: any) => {
		const fullName = [user.lastName, user.firstName].filter(Boolean).join(' ')
		return {
			value: user.id,
			label: fullName || user.email
		}
	})
}
